import photo from "../assets/diya.jpg";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";
import ScrollingProjects from "../components/ScrollingProjects";
import { Link } from "react-router-dom";

function Home() {
  return (
    <section className="min-h-screen bg-gradient-to-br from-[#0b1220] via-[#0f1d3a] to-[#0a1f44] text-white relative overflow-hidden py-24 md:flex md:items-center">
      {/* Background Glow */}

      <div className="absolute w-[600px] h-[600px] bg-blue-500/20 blur-[160px] rounded-full top-10 left-10"></div>
      <div className="absolute w-[500px] h-[500px] bg-indigo-500/20 blur-[140px] rounded-full bottom-0 right-10"></div>

      {/* Main Container */}

      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 px-4 md:px-6 items-center">
        {/* LEFT PROFILE CARD */}

        <div className="relative bg-[#1b2433]/90 backdrop-blur-md rounded-2xl p-8 md:p-12 shadow-[0_0_60px_rgba(59,130,246,0.25)] w-full max-w-[360px] md:max-w-[420px] flex flex-col justify-center items-center text-center mx-auto hover:scale-105 transition">
          {/* Glow Border */}
          <div className="absolute -inset-[3px] bg-gradient-to-r from-blue-500 to-indigo-500 blur-xl opacity-30 rounded-2xl -z-10"></div>

          {/* Profile Image */}

          <img
            src={photo}
            alt="Diya"
            className="w-36 h-36 md:w-48 md:h-48 rounded-xl object-cover"
          />

          <h2 className="text-3xl font-bold mt-6">Diya Jacob</h2>

          <p className="text-gray-400 text-lg">Software Developer</p>

          <p className="text-gray-500 text-sm">India</p>

          {/* Social Icons */}

          <div className="flex gap-8 mt-6 text-2xl text-gray-300">
            <a
              href="https://github.com/diyajacob001"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition"
            >
              <FaGithub />
            </a>

            <a
              href="https://www.linkedin.com/in/diya-jacob-34547818a/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition"
            >
              <FaLinkedin />
            </a>

            <a
              href="mailto:diyajacob.tech@gmail.com"
              className="hover:text-blue-400 transition"
            >
              <FaEnvelope />
            </a>
          </div>

          {/* Contact Button */}

          <Link to="/contact">
            <button className="mt-6 md:mt-10 border border-blue-400 text-blue-400 px-8 py-3 rounded-lg font-semibold hover:bg-blue-400 hover:text-white transition">
              Contact Me
            </button>
          </Link>

          <a
            href="/Diya.pdf"
            download
            className="mt-4 text-sm text-blue-400 hover:underline"
          >
            Download Resume
          </a>
        </div>

        {/* RIGHT CONTENT */}

        <div>
          <h1 className="text-3xl md:text-5xl font-bold leading-tight">
            React Native <span className="text-blue-400">|</span> React.js
            Developer
          </h1>

          <p className="text-gray-400 mt-6 max-w-xl leading-relaxed">
            I’m a React Native and React.js developer with 6+ years of
            experience building scalable mobile and web applications across
            e-commerce, blockchain, insurance, and retail domains. I specialize
            in creating high-performance apps using React Native, React.js,
            Redux, TypeScript, and modern frontend technologies.
          </p>

          {/* Stats */}

          <div className="grid grid-cols-3 gap-6 mt-10 max-w-sm">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold">6+</h2>

              <p className="text-gray-400 text-sm">Years Experience</p>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold">15+</h2>

              <p className="text-gray-400 text-sm">Projects</p>
            </div>

            <div>
              <h2 className="text-3xl md:text-4xl font-bold">10+</h2>

              <p className="text-gray-400 text-sm">Clients</p>
            </div>
          </div>

          {/* Featured Projects */}

          <div className="mt-12 md:mt-16">
            <ScrollingProjects />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
